import { Button, CardMedia } from "@mui/material";
import { useCallback, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Carousel from "react-material-ui-carousel/dist/components/Carousel";

interface ISwipper {
  images: string[];
  size: {
    width: string;
    height: string;
  };
  autoPlay?: boolean;
  onImageClick(): void;
  close(): void;
}


const Swipper: React.FC<ISwipper> = ({ images, size, onImageClick, autoPlay = false, close }) => {
  const [activeChild, setActiveChild] = useState(0);
  const isMobile = window.innerWidth < 500 ? false : true;
  const isScrollablle = images.length > 1;
  const {t} = useTranslation();

  const changeChild: any = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "ArrowLeft") {
        setActiveChild((a: any) => (a - 1 < 0 ? images.length - 1 : a - 1));
      } 
      else if (e.key === "ArrowRight") {
        setActiveChild((a: any) => (a + 1 > images.length - 1 ? 0 : a + 1));
      }
      else if (e.key === "Escape") {
        close();
      }
    }, [images, close]
  );

  useEffect(() => {
    document.addEventListener("keydown", changeChild);

    return function cleanup() {
      document.removeEventListener("keydown", changeChild);
    };
  });

  return (
    <>
      <Carousel
          index={activeChild}
          fullHeightHover={false}     
          navButtonsProps={{          
              style: {
                  backgroundColor: '#29ADB2',
              }
          }} 
          navButtonsWrapperProps={{  
              style: {
                  bottom: '0',
                  top: 'unset',
                  height: "initial",
                  paddingLeft: "10vw",
                  paddingRight: "10vw"
              }
          }} 
          indicatorIconButtonProps={{
            style: {
                padding: '10px',    
                color: '#29ADB2'       
            }
        }}
        activeIndicatorIconButtonProps={{
          style: {
              color: 'white' 
          }
      }}
        swipe={true}
        autoPlay={autoPlay}
        navButtonsAlwaysVisible={isScrollablle && isMobile}
        animation="fade"        
        >
        {images.map((step, index) => (
          <CardMedia
            key={index}
            sx={{
              padding: "1em 1em 0 1em",
              objectFit: "contain",
            }}
            component="img"
            height={size.height}
            width={size.width}
            title="wheel"
            image={require(`../Assets/${step.trim()}`)}
            onClick={onImageClick}
            loading="lazy"
          ></CardMedia>
        ))}
      </Carousel>
      <Button onClick={close} variant="outlined" sx={{ borderColor: "rgb(41, 173, 178)", borderWidth: "4px", fontSize: "20px", color:"#FFFFFF", display: "block", marginLeft: "auto",marginRight: "auto"}}>{t("common.close")}</Button>  
    </>
  );
};

export default Swipper;

